import React, { useState } from "react"
import { useLocation } from "react-router-dom"
import { ChangeHealthcareLogs } from "../../types/ChangeHealthcareLog"
import { Center, Divider } from "@chakra-ui/layout"
import ChangeHealthcareLogsTable from "../../components/changehealthlogs/ChangeHealthcareLogsTable"
import SearchInputs from "../../components/changehealthlogs/SearchInputs"
import { theme } from "../../utils/theme"
import { ChakraProvider } from "@chakra-ui/react"

export default function ChangeHealthcareLogsPage(): JSX.Element {
  const [data, setData] = useState<ChangeHealthcareLogs>()
  const location = useLocation()
  const initialEmployeeId = new URLSearchParams(location.search).get("employee_id") ?? undefined

  return (
    <>
      <ChakraProvider theme={theme}>
        <SearchInputs setData={setData} initialEmployeeId={initialEmployeeId} />
        <Center height="50px">
          <Divider orientation="horizontal" />
        </Center>
        <ChangeHealthcareLogsTable logs={data?.changeHealthcareLogs} />
      </ChakraProvider>
    </>
  )
}
